import React from "react";
import { Row, Col, Card, CardBody, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Charts
import IndusBenchMark1 from "pages/AllCharts1/echart1/IndusBenchMark1";
import CreditorsDay1 from "pages/AllCharts1/echart1/CreditorsDay1";
import DebtCredt1 from "pages/AllCharts1/echart1/DebtCredt1";
import RevnewProfit1 from "pages/AllCharts1/echart1/RevnewProfit1";
import DebtorsDay1 from "pages/AllCharts1/echart1/DebtorsDay1";
import CashFlowIndi1 from "pages/AllCharts1/echart1/CashFlowIndi1";
import WorkingCapitalChart from "pages/AllCharts1/echart1/WorkingCapitalChart";
import EntityValuePieChart from "pages/AllCharts1/echart1/EntityValuePieChart";
import BusisPieChart from "pages/AllCharts1/echart1/BusisPieChart";

const EChart = () => {
  document.title = "ECharts | Bvo -Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {/* Render Breadcrumb */}
          <Breadcrumbs maintitle="Bvo" title="Charts" breadcrumbItem="ECharts" />

          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  {/* <h4 className="mt-0 header-title mb-4">Industrial Benchmark Indicators</h4> */}
                  <div id="bubble-chart" className="e-chart">
                    <IndusBenchMark1 />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Creditors' Day Outstanding</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <CreditorsDay1 />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Chart Entity Value Components</h4>
                  <div id="bubble-chart" className="e-chart">
                    <EntityValuePieChart/>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Business Value Component</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <BusisPieChart/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Debtors and Creditors</h4>
                  <div id="Debtors and Creditors" className="e-chart">
                    <DebtCredt1 />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Revenue and Profit</h4>
                  <div id="DebetorsDayOutStanding" className="e-chart">
                    <RevnewProfit1 />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Days Outstanding</h4>
                  <div id="line-chart" className="e-chart">
                    <DebtorsDay1 />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Cash Flow Indicators</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <CashFlowIndi1 />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {/* <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Profit Data Over Time</h4>
                  <div id="doughnut-chart" className="e-chart">
                    <RevnewProfit1/>
                  </div>
                </CardBody>
              </Card>
            </Col> */}
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Working Capital</h4>
                  <div id="doughnut-chart" className="e-chart">
                    <WorkingCapitalChart/>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>


        </Container>
      </div>
    </React.Fragment>
  );
};

export default EChart;
